var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashcanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin-View-Student-Application---Full-data",
    transform: "translate(-866.000000, -2367.000000)",
    stroke: "#D55555",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("line", {
    x1: 867,
    y1: 2370.68516,
    x2: 881.065728,
    y2: 2370.78025,
    id: "Path-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.254192,2370.68516 L868.254192,2384.68516 C868.254192,2385.23745 868.701907,2385.68516 869.254192,2385.68516 L878.907648,2385.68516 C879.459932,2385.68516 879.907648,2385.23745 879.907648,2384.68516 L879.907648,2370.7271 L879.907648,2370.7271",
    id: "Path-4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 871.043756,
    y1: 2373.73653,
    x2: 871.043756,
    y2: 2382.74138,
    id: "Path-5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 873.95712,
    y1: 2373.73653,
    x2: 873.95712,
    y2: 2382.74138,
    id: "Path-6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 876.987018,
    y1: 2373.73653,
    x2: 876.987018,
    y2: 2382.74138,
    id: "Path-6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.694152,2370.68516 L870.694152,2369 C870.694152,2368.44772 871.141867,2368 871.694152,2368 L876.686225,2368 C877.23851,2368 877.686225,2368.44772 877.686225,2369 L877.686225,2370.73271 L877.686225,2370.73271",
    id: "Path-7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcanIcon);
export default __webpack_public_path__ + "static/media/trashcan-icon.7c99d256610de608887e34dabd568fca.svg";
export { ForwardRef as ReactComponent };